import * as fromActions from '../actions/prescriptor.action';
import { PrescriptorData } from '../models/store.model';

export const prescriptorInitialState: PrescriptorData | null = null;

export function prescriptorDataReducer(
    state = prescriptorInitialState,
    action: fromActions.PrescriptorDataActions
): PrescriptorData | null {

    switch (action.type) {

        case fromActions.SETPRESCRIPTORDATA:
            return action.prescriptor;

        case fromActions.UNSETPRESCRIPTORDATA:
            return prescriptorInitialState;

        default:
            return state;
    }
}

